export default {
  total_orders: {
    title: 'Tilaukset',
    orders: 'Tilaukset:',
    sales_volume: 'Myyntimäärä:',
    delivery_costs: 'Toimituskulut:',
  },
  cash_orders: {
    title: 'Maksu käteisellä / ovella',
    orders: 'Tilaukset:',
    sales_volume: 'Myyntimäärä:',
    delivery_costs: 'Toimituskulut:',
  },
  online_orders: {
    title: 'Verkkomaksut',
    orders: 'Tilaukset:',
    sales_volume: 'Myyntimäärä:',
    delivery_costs: 'Toimituskulut:',
  },
  total: 'Yhteensä',
  collected_taxes_list: {
    title: {
      online: 'Verkkomaksu',
      cash: 'Käteismaksu',
    },
    table: {
      products_breakdown: {
        fields: {
          product: 'Tuote',
          quantity: 'Määrä',
          total: 'Yhteensä',
        },
        labels: {
          total_refunded: 'Hyvitetty',
        },
      },
      tax_breakdown: {
        fields: {
          tax_percentage: 'Vero %',
          product_type: 'Tyyppi',
          netto: 'Netto',
          tax: 'Vero',
          brutto: 'Yhteensä',
        },
        product_types: {
          product: 'Tuotteet {{percentage}}%',
          order_method_fee: 'Toimitusmaksut {{percentage}}%',
          customer_service_fee: 'Verkkomaksun lisämaksu',
        },
      },
    },
  },
};
